<div class="flex justify-center items-center gap-x-1 max-w-4xl bg-[#def7ec] rounded-3xl">
  <mat-icon color="primary" aria-label="Info icon" class="scale-75 ml-2">info</mat-icon>
  <span class="mat-primary-color text-sm font-light py-2 -mr-2">{{data}}</span>
  <button mat-icon-button color="primary" (click)="onCloseClicked()" aria-label="Close icon" class="scale-75">
    <mat-icon>close</mat-icon>
  </button>
</div>
